const intro = `In the solace of mystical woods, a grieving lumberjack emerges from the
        shadows day-after-day, surviving the rebirth of a nation post-war; a
        victory overshadowed by profound loss. Yet, my life unfolds in a
        monotony of routine, a self-imposed duty for the betterment of my
        nation. Each day is lived not for splendor but for the fulfillment of a
        solemn obligation. My heart echoes with the ache of parted love, weaving
        nostalgia into the mundane woes of the present. I yearn to break free
        from this aimless existence...`

export default intro;